import { serviceLocator } from '@/utils/providers/serviceLocator'
import { useQuery } from '@/utils/asyncStateManagement/useQuery'
import type { ChatRepository } from '../repositories/ChatRepository'
import type { ChatNotificationHistoryFilterEntity } from '../entities/ChatNotificationHistoryFilterEntity'
import { useNotificationStore } from '../../presentation/stores/notificationStore'

export async function getChatNotificationHistoryCase(
  filterData: ChatNotificationHistoryFilterEntity,
  skip?: boolean
) {
  const newRepository = serviceLocator.getService<ChatRepository>('ChatService')
  const notificationStore = useNotificationStore()
  const { data } = await useQuery({
    fetcher: async () => await newRepository?.getNotificationHistory(filterData),
    key: 'chat',
    filterData: JSON.stringify(filterData)
  })

  if (data.value?.error) return

  if (!skip) notificationStore.setMessages(data.value?.items ?? [])

  return data.value
}
